/**
 * Une rangée de logos sur une bande grise — les moyens de paiement de la
 * tarification d'origine, classe pour classe.
 *
 * La bande va d'un bord à l'autre de l'écran : ce bloc est fait pour la mise
 * en page pleine largeur. Dans une carte, il en prendrait la largeur.
 *
 * ── L'adresse d'un logo n'est pas prise sur parole ──────────────────────────
 * Le serveur la valide déjà (IsSafeHref : chemin relatif ou https:). Le rendu
 * refait le contrôle : un contenu importé autrement, ou une règle serveur
 * assouplie un jour, ne doit pas suffire à charger une image en clair ni à
 * glisser un `javascript:` dans un src.
 */
const adresseSure = (adresse) => {
    const a = String(adresse || '').trim();
    if (!a || a.startsWith('//')) return false;
    return a.startsWith('/') || a.startsWith('https://');
};

const LogosBloc = ({ bloc }) => {
    const logos = (Array.isArray(bloc?.logos) ? bloc.logos : []).filter(l => adresseSure(l?.image));
    if (logos.length === 0) return null;

    return (
        <section className="py-12 bg-gray-50" data-testid="bloc-logos">
            <div className="max-w-3xl mx-auto px-4 text-center">
                {bloc.titre && (
                    <h3 className="text-lg font-semibold text-gray-900 mb-4">{bloc.titre}</h3>
                )}
                <div className="flex items-center justify-center gap-6 flex-wrap">
                    {logos.map((logo, i) => (
                        <img key={i} src={logo.image.trim()} alt={logo.alt || ''} className="h-8" />
                    ))}
                </div>
                {bloc.mention && (
                    <p className="text-sm text-gray-500 mt-4">{bloc.mention}</p>
                )}
            </div>
        </section>
    );
};

export default LogosBloc;
